module.exports = __webpack_public_path__ + "EG.png?d92a29bc70a4f0ef10fe7bba59285a68";